//@flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import styles from './ProfileHeaderData.scss';
import getter from 'dibs-object-getter';

import { wrapped as ProfileIcon } from './ProfileIcon';
import { ProfileLocation } from './ProfileLocation';
import { ProfileTabs } from './ProfileTabs';
import { ProfileContactInfo } from './ProfileContactInfo';

import type { ProfileHeaderData_tradeFirm as TradeFirmType } from './__generated__/ProfileHeaderData_tradeFirm.graphql';
import type { ProfileHeaderData_geography as Geography } from './__generated__/ProfileHeaderData_geography.graphql';
import type { PageType } from '../constants';

type Props = {
    tradeFirm: ?TradeFirmType,
    geography: ?Geography,
    isEditMode: boolean,
    onChangeTab: (pageType: PageType) => void,
    currentPage: PageType,
};

export const ProfileHeaderDataComponent = (props: Props) => (
    <div className={`${styles.wrapper} rowFlex`}>
        <ProfileIcon isEditMode={props.isEditMode} tradeFirm={(props.tradeFirm: ?Object)} />
        <div className={`${styles.profileDataWrapper} rowFlex rowXsBottom colXsStretch`}>
            <div className={styles.nameLocation}>
                <h1 className={`${styles.name} ${styles.ellipsis}`}>
                    {getter(props.tradeFirm).value('name')}
                </h1>
                <ProfileLocation
                    tradeFirm={(props.tradeFirm: ?Object)}
                    geography={(props.geography || null: ?Object)}
                    isEditMode={props.isEditMode}
                />
            </div>
            <ProfileContactInfo
                tradeFirm={(props.tradeFirm: ?Object)}
                isEditMode={props.isEditMode}
            />
            <div className={`${styles.divider} colXs12 colXsCenter`} />
            <ProfileTabs
                isEditMode={props.isEditMode}
                onChangeTab={props.onChangeTab}
                currentTab={props.currentPage}
                tradeFirm={(props.tradeFirm: ?Object)}
            />
        </div>
    </div>
);

export const ProfileHeaderData = createFragmentContainer(ProfileHeaderDataComponent, {
    geography: graphql`
        fragment ProfileHeaderData_geography on Geography {
            ...ProfileLocation_geography
        }
    `,
    tradeFirm: graphql`
        fragment ProfileHeaderData_tradeFirm on TradeFirmType {
            ...ProfileLocation_tradeFirm
            ...ProfileTabs_tradeFirm
            ...ProfileContactInfo_tradeFirm
            ...ProfileIcon_tradeFirm
            name
        }
    `,
});
